export const getHandednessColor = (handedness) => {
  return handedness === 'RH' ? 'blue.500' : 'green.500';
};
